import { sendWebsocketMessage } from '../../../../../App';
/**
 * Request all the expiration dates available for a certain stock's options
 * @param {String} requestKey we will send back this key in the return message in order for the component that sent this to know which message is his
 * @param {String} requestSymbol the symbol that you are requesting expiration dates for
 * @param {String} requestDataSource the ds that you are requesting expiration dates for
 * @param {boolean} notTodayExpiration whether or not to exclude any expirations expiring today
 * @returns
 */
export function requestOptionExpirationDates(
  requestKey,
  requestSymbol,
  requestDataSource,
  notTodayExpiration
) {
  if (
    requestKey === undefined ||
    requestSymbol === undefined ||
    requestDataSource === undefined
  ) {
    console.log('option request had undefined value');
    return;
  }
  if (notTodayExpiration === undefined) {
    notTodayExpiration = false;
  }
  const message = {
    key: requestKey,
    symbol: requestSymbol,
    dataSource: requestDataSource,
    messageType: 'optionExpirationDates',
    notExpiringToday: notTodayExpiration,
  };
  sendWebsocketMessage(message);
}
